 import { auth } from './firebase';

// Sign Up
export const doCreateUser = (email, password) =>
  auth.createUserWithEmailAndPassword(email, password);

// Sign In
export const doSignIn = (email, password) => 
  auth.signInWithEmailAndPassword(email, password);

// Sign out
export const doSignOut = () =>
  auth.signOut();

// Password Reset
export const doPasswordReset = (email) =>
  auth.sendPasswordResetEmail(email);

// Password Change
export const doPasswordUpdate = (password) =>
  auth.currentUser.updatePassword(password);

export const onStateChange = (cb) =>
	auth.onAuthStateChanged(cb);

export const currentUser = () =>
	auth.currentUser;



// WEBPACK FOOTER //
// ./src/firebase/auth.js